import React from 'react';

import { LoadingIcon } from '../../assets/Icons';
import './pageLoading.css';

function PageLoading() {
  return (
    <div className="pageLoading">
      <LoadingIcon />
    </div>
  );
}

export default PageLoading;
